import React from "react";
import AppRoute from "./layout/AppRoute";

const App = () => <AppRoute />;

export default App;
